import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, withRouter, Link } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Helmet } from 'react-helmet';
import IMAGES from 'modules/assets/web';
import Toast from 'modules/toast';
import queryString from 'query-string';
import apiFetch from 'modules/api-fetch';
import * as Yup from 'yup';

class SetPasswordPage extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  state = {
    redirect: false,
    showError: false,
  };

  componentDidMount() {
    window.location.href = 'https://nerdfitness.com/lostpassword?coaching=true';
  }

  setPassword = async values => {
    const { email, code } = queryString.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });

    const config = {
      url: 'Infusionsoft/ResetPassword',
      method: 'POST',
      query: {
        email,
        password: values.password,
        code,
      },
      body: {},
    };

    try {
      const response = await apiFetch(config);

      if (response.includes('success')) {
        Toast.success('Password set! Redirecting to sign in...');
        setTimeout(() => {
          this.setState({
            redirect: true,
          });
        }, 1000);
      } else {
        Toast.error(
          'Encountered an error. E-mail not found, invalid token, or token already used.',
        );
        this.setState({
          showError: true,
        });
      }
    } catch (er) {
      Toast.error(
        'Encountered an error. E-mail not found, invalid token, or token already used.',
      );
      this.setState({
        showError: true,
      });
      console.devLog.info('Error:', er);
    }
  };

  validationSchema = () =>
    Yup.object({
      password: Yup.string()
        .min(6, 'Minimum password length is 6 characters')
        .max(24, 'Maximum password length is 24 characters')
        .required('Password is required'),
      passwordConfirm: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Password confirm is required'),
    });

  render() {
    const { email, code } = queryString.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    if (this.state.redirect) {
      return (
        <Redirect
          to={{
            pathname: '/signin',
            search: `?email=${encodeURIComponent(email)}&setPassword=true`,
          }}
        />
      );
    }

    const disabled = !code || !email;
    return (
      <div className="signin-wrapper col-xs-10 col-sm-8 col-md-6 col-lg-4 mx-auto">
        <Helmet>
          <title>Set Password</title>
        </Helmet>

        <Formik
          initialValues={{
            email,
            password: '',
          }}
          validationSchema={this.validationSchema}
          onSubmit={this.setPassword}
          render={() => (
            <Form className="form-signin">
              <img
                className="mb-4 d-block mx-auto w-50"
                src={IMAGES.COACHING_1}
                alt=""
              />

              <h1 className="h3 mb-3 font-weight-normal text-center">
                Set your Account Password
              </h1>
              <div className="form-group">
                <label htmlFor="name">E-mail Address</label>
                <Field
                  type="email"
                  name="email"
                  readOnly
                  disabled
                  placeholder="Your E-mail"
                  className="form-control form-control-sm"
                />
                <ErrorMessage name="email" />
              </div>
              <div className="form-group">
                <label htmlFor="name">Password</label>
                <Field
                  type="password"
                  name="password"
                  placeholder="Password"
                  className="form-control form-control-sm"
                />
                <ErrorMessage name="password" />
              </div>
              <div className="form-group">
                <label htmlFor="name">Verify Password</label>
                <Field
                  type="password"
                  name="passwordConfirm"
                  placeholder="Password verify"
                  className="form-control form-control-sm"
                />
                <ErrorMessage name="passwordConfirm" />
              </div>
              {(disabled || this.state.showError) && (
                <div
                  className="p-2 mb-2 text-center pt-4"
                  style={{
                    backgroundColor: 'rgba(199, 55, 55, 0.2)',
                    borderRadius: '10px',
                  }}
                >
                  <p>
                    You are missing the reset code and/or email required to set
                    an account password.{' '}
                    {this.state.showError && (
                      <span>
                        (Or an error was encountered submitting this request.)
                      </span>
                    )}
                  </p>
                  <p style={{ color: '#C73737' }}>
                    <Link to="/resetpassword">
                      You can trigger a password reset with a new code at the
                      password reset page here.
                    </Link>
                  </p>
                </div>
              )}
              <button
                type="submit"
                disabled={disabled}
                readOnly={disabled}
                className="btn btn-lg btn-primary btn-block"
              >
                Set Password
              </button>
              <div className="mt-2">
                <p className="font-italic">
                  If your password is already set, you can head{' '}
                  <Link to="/signin">directly to the sign in page here.</Link>
                </p>
              </div>
              <div className="mt-2">
                <p className="font-italic">
                  If you encounter any issues setting your password please reach
                  out to coaching@nerdfitness.com and we'll get you squared away
                  ASAP.
                </p>
              </div>
            </Form>
          )}
        />
      </div>
    );
  }
}

export default withRouter(SetPasswordPage);

// https://getbootstrap.com/docs/4.0/examples/sign-in/
